import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './SubRolesSwitch.css';
import _ from 'lodash';
import { SUB_ROLES_TRANSLATIONS } from '../../../reducers/account/role';

class SubRolesSwitch extends Component {
    constructor(props) {
        super(props);

        this.itemsRefs = [];

        this.state = {
            indicatorCurrentSubRole: null,
            indicatorWidth: 0,
            indicatorPosition: 0,
            isIndicatorAnimated: false
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResizeWindow);
        this.updateIndicator(this.props.currentSubRole);
    }

    onResizeWindow = () => {
        this.updateIndicator(this.props.currentSubRole)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentSubRole !== this.props.currentSubRole && this.state.indicatorCurrentSubRole !== this.props.currentSubRole) {
            this.updateIndicator(this.props.currentSubRole);
        } else if (!_.isEqual(prevProps.subRoles, this.props.subRoles)
            || !_.isEqual(prevProps.selectedLanguage, this.props.selectedLanguage)) {
            this.updateIndicator(this.props.currentSubRole);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResizeWindow);
    }

    render() {
        return (
            <div className={`sub-roles-switch-container  ${_.toLower(this.props.currentSubRole)}`}>
                {
                    _.map(this.props.subRoles, (subRole, i) => (
                        <div
                            className="sub-roles-switch-item"
                            key={subRole}
                            onClick={this.onChangeCurrentSubRole(subRole)}
                            ref={(elem) => { this.itemsRefs[i] = elem; }}
                        >
                            {_.get(this.props.translation, 'roles.' + SUB_ROLES_TRANSLATIONS[subRole])}
                        </div>
                    ))
                }
                <div
                    className="sub-roles-switch-indicator"
                    style={{
                        width: this.state.indicatorWidth,
                        left: this.state.indicatorPosition,
                        transition: this.state.isIndicatorAnimated ? "" : "none"
                    }}
                />
            </div>
        )
    }

    onChangeCurrentSubRole = (subRole) => () => {
        this.updateIndicator(subRole, true);
        this.props.onChangeCurrentSubRole(subRole);
    }

    updateIndicator = (subRole, isAnimate = false) => {
        let itemIndex = _.indexOf(this.props.subRoles, subRole);
        let currentItemNode = ReactDOM.findDOMNode(this.itemsRefs[itemIndex]);
        let leftPosition = 0;
        let currentItemInfo = currentItemNode ? currentItemNode.getBoundingClientRect() : null;

        if (itemIndex > 0 && currentItemInfo) {
            let firstItemNode = ReactDOM.findDOMNode(this.itemsRefs[0]);
            if (firstItemNode) {
                let firstItemInfo = firstItemNode.getBoundingClientRect();
                leftPosition = currentItemInfo.x - firstItemInfo.x;
            }
        }

        this.setState({
            indicatorCurrentSubRole: subRole,
            indicatorWidth: currentItemInfo ? currentItemInfo.width : 0,
            indicatorPosition: leftPosition,
            isIndicatorAnimated: isAnimate
        })
    }
}

SubRolesSwitch.propTypes = {
    currentSubRole: PropTypes.string.isRequired,
    subRoles: PropTypes.array.isRequired,
    translation: PropTypes.object
};

export default SubRolesSwitch;



// WEBPACK FOOTER //
// ./src/components/commonComponents/subRolesSwitch/SubRolesSwitch.js